import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BaseButton from 'DesignSystem/Buttons/BaseButton';
import ButtonSizes from 'DesignSystem/Buttons/ButtonSizes';
import RecipientPreviewToggleButtonWithTooltip from 'SelfServeBuilder/SelfServeBuilderToolbar/RecipientPreviewToggleButtonWithTooltip';

const ToggleButton = (props) => {
  const leftButtonClasses = classnames(
    'left-toggle-button',
    { 'toggled-on': props.isLeftToggled },
    { 'toggled-off': !props.isLeftToggled },
  );

  const rightButtonClasses = classnames(
    'right-toggle-button',
    { 'toggled-on': props.isRightToggled },
    { 'toggled-off': !props.isRightToggled },
  );

  return (
    <div className={`toggle-button-container ${props.additionalClassNames}`}>
      <BaseButton
        buttonRef={props.leftButtonRef}
        buttonType="secondary"
        className={leftButtonClasses}
        onClick={props.onClickLeft}
        size={props.size}
      >
        {props.leftText}
      </BaseButton>
      <RecipientPreviewToggleButtonWithTooltip>
        <BaseButton
          buttonType="secondary"
          className={rightButtonClasses}
          onClick={props.onClickRight}
          size={props.size}
        >
          {props.rightText}
        </BaseButton>
      </RecipientPreviewToggleButtonWithTooltip>
    </div>
  );
};

ToggleButton.defaultProps = {
  additionalClassNames: '',
  leftButtonRef: null,
  onClickLeft: () => null,
  onClickRight: () => null,
  size: 'md',
};

ToggleButton.propTypes = {
  additionalClassNames: PropTypes.string,
  isLeftToggled: PropTypes.bool.isRequired,
  isRightToggled: PropTypes.bool.isRequired,
  leftText: PropTypes.string.isRequired,
  leftButtonRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  onClickLeft: PropTypes.func,
  onClickRight: PropTypes.func,
  rightText: PropTypes.string.isRequired,
  size: PropTypes.oneOf(ButtonSizes),
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/ToggleButton.jsx